// extracted by mini-css-extract-plugin
export default {"tasks":"oP-z","task":"pP-z","svg":"qP-z","text":"rP-z"};